import { useState } from "react";
import {
    DeleteOutline,
    EditOutlined,
    ExpandLess,
    ExpandMore,
} from "@mui/icons-material";
import {
    Box,
    Button,
    Collapse,
    IconButton,
    Paper,
    Stack,
    Tooltip,
    Typography,
} from "@mui/material";

import { abaLabel, abaNoCatalogo } from "../../../utils/dashboardSchemaDraft";
import SlotRow from "./slotRow";

// abas fora do catálogo aparecem com aviso, não são escondidas nem apagadas
export default function AbaCard({
    aba,
    catalogoAbas,
    aberta,
    onToggle,
    onRemover,
    onEditarAba,
    onChangeSlotName,
    onChangeSlotItems,
    onMoverSlot,
    onRemoverSlot,
    onAdicionarSlot,
    sugestoes,
    notify,
    somenteLeitura = false,
    styles,
}) {
    const [mostrarTodasAbas, setMostrarTodasAbas] = useState(false);

    const noCatalogo = abaNoCatalogo(aba.key, catalogoAbas);
    const rotulo = abaLabel(aba.key, catalogoAbas);
    const entradaCatalogo = (catalogoAbas || []).find(
        (item) => item.key === aba.key,
    );

    const slotsValidos = (aba.slots || []).filter(
        (slot) => slot.name?.trim() && (slot.items || []).length > 0,
    ).length;

    return (
        <Paper variant="outlined" sx={styles.abaCard}>
            <Stack
                direction="row"
                alignItems="center"
                gap={1}
                sx={styles.abaHeader}
                onClick={onToggle}
            >
                <IconButton size="small" sx={{ p: 0.25 }}>
                    {aberta ? (
                        <ExpandLess fontSize="small" />
                    ) : (
                        <ExpandMore fontSize="small" />
                    )}
                </IconButton>

                <Typography sx={styles.abaChaveTitulo}>{aba.key}</Typography>

                {rotulo !== aba.key && (
                    <Typography sx={styles.abaRotulo}>{rotulo}</Typography>
                )}

                <Typography sx={styles.abaContagem}>
                    {slotsValidos} {slotsValidos === 1 ? "métrica" : "métricas"}
                </Typography>

                <Box flex={1} />

                {/* {!noCatalogo && (
                    <Tooltip title="Esta aba não está no catálogo. Ela continua salva, mas o app do cliente só renderiza abas que conhece.">
                        <Typography sx={styles.abaAviso}>
                            aba fora do catálogo
                        </Typography>
                    </Tooltip>
                )} */}

                {!somenteLeitura && entradaCatalogo && (
                    <Tooltip title="Editar rótulo da aba">
                        <IconButton
                            size="small"
                            sx={{ p: 0.25 }}
                            onClick={(event) => {
                                event.stopPropagation();
                                onEditarAba(event.currentTarget, entradaCatalogo);
                            }}
                        >
                            <EditOutlined sx={{ fontSize: "0.95rem" }} />
                        </IconButton>
                    </Tooltip>
                )}

                {!somenteLeitura && (
                    <Tooltip title="Remover esta aba do schema deste modelo">
                        <IconButton
                            size="small"
                            sx={{ p: 0.25 }}
                            onClick={(event) => {
                                event.stopPropagation();
                                onRemover();
                            }}
                        >
                            <DeleteOutline
                                sx={{ fontSize: "0.95rem" }}
                                color="error"
                            />
                        </IconButton>
                    </Tooltip>
                )}
            </Stack>

            <Collapse in={aberta} unmountOnExit>
                <Box sx={styles.colunasHeader}>
                    <Box sx={styles.colSlot}>
                        <Typography sx={styles.colunaLabel}>Métrica</Typography>
                    </Box>
                    <Box sx={styles.colItens}>
                        <Typography sx={styles.colunaLabel}>
                            Nomes dos itens no Zabbix
                        </Typography>
                    </Box>
                    {!somenteLeitura && (
                        <Box sx={{ ...styles.colAcoes, width: "168px" }} />
                    )}
                </Box>

                {(aba.slots || []).length === 0 && (
                    <Box sx={{ px: 1.5, py: 2 }}>
                        <Typography variant="caption" color="text.disabled">
                            Nenhuma métrica nesta aba.
                        </Typography>
                    </Box>
                )}

                {(aba.slots || []).map((slot, index) => (
                    <SlotRow
                        key={slot.id}
                        slot={slot}
                        aba={aba.key}
                        sugestoes={sugestoes}
                        notify={notify}
                        styles={styles}
                        somenteLeitura={somenteLeitura}
                        mostrarTodasAbas={mostrarTodasAbas}
                        onChangeName={(nome) => onChangeSlotName(slot.id, nome)}
                        onChangeItems={(itens) => onChangeSlotItems(slot.id, itens)}
                        onMover={(direcao) => onMoverSlot(slot.id, direcao)}
                        onRemover={() => onRemoverSlot(slot.id)}
                        podeSubir={index > 0}
                        podeDescer={index < aba.slots.length - 1}
                    />
                ))}

                {!somenteLeitura && (
                <Box sx={styles.abaFooter}>
                    <Button
                        size="small"
                        onClick={onAdicionarSlot}
                        sx={styles.linkAdicionar}
                    >
                        + Adicionar métrica
                    </Button>

                    {/* O escopo é dica de organização, não regra: este toggle libera
                        slots criados em outras abas para reaproveitamento. Fica no
                        rodapé do card, e não por linha, para valer para a aba toda. */}
                    {/* <Tooltip title="Métricas criadas dentro de outra aba também passam a ser oferecidas nas linhas acima">
                        <Button
                            size="small"
                            onClick={() => setMostrarTodasAbas((prev) => !prev)}
                            sx={styles.linkDiscreto}
                        >
                            {mostrarTodasAbas
                                ? "mostrando métricas de todas as abas"
                                : "ver métricas de outras abas"}
                        </Button>
                    </Tooltip> */}
                </Box>
                )}
            </Collapse>
        </Paper>
    );
}
